<template>
    <div class="invite-accounts-clients">
        <md-dialog 
            :md-active.sync="showDialog" 
            class="dialog--invite-accounts-clients" 
            @md-opened="bodyAddNoScroll"
            @md-closed="bodyRemoveNoScroll"
            @md-clicked-outside="bodyRemoveNoScroll"
        >
            <div class="form-wrap">
                <md-dialog-title>
                    <span>Edit {{userType}} list</span>
                    <button class="btn btn--close" @click="cancel"></button>
                </md-dialog-title>
                <div class="form__content form__content--wide"  :key="refreshKey">                        
                    <div class="user-list-wrap">                        
                        <div v-for="c in users" :key="c.id" class="user-block">
                            <div class="data">
                                <div class="name" >{{c.name}} </div>
                                <div class="pending_message" v-if="pending(c)">user invited but <b>not registered yet!</b></div>
                                <div class="email">{{c.email}}</div>
                            </div>                            
                            <div>
                                <div v-if="pending(c)" >
                
                                    <button v-if="invited(c) && $store.state.user.user_type != 'client'" class="btn icon-btn icon-btn--del-red "  @click="removeAccountForBrand(c)" title="Delete">                                       
                                    </button>
                                    <button v-else class="btn btn-blue" @click="addAccountForBrand(c)">
                                        Add to Brand
                                    </button>
                                </div>
                                <div v-else-if="invited(c)" class="btns-wrap">
                                    <div class="user-invited">Added</div>  
                                        <button v-if="$store.state.user.user_type != 'client'" class="btn icon-btn icon-btn--del-red "  @click="removeAccountForBrand(c)" title="Delete">                                       
                                    </button>
                                </div>
                                <div v-else>
                                    <button class="btn btn-blue" @click="addAccountForBrand(c)">
                                        Add to Brand
                                    </button>
                                </div>
                            </div>
                        </div>       
                    </div>                                                                             
                    <div class="divider" ></div>
                    <div class="form__content form__content--inner form--add-new-user-to-brand" v-if="userType=='client' && accountView">
                        <h3>Add new {{userType}}</h3>
                        <validation-observer v-slot="{ handleSubmit }" tag="div" class="form-wrap">
                            <form @submit.prevent="handleSubmit(inviteAccount)" class="form"> 
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <md-field>                            
                                        <label>{{userType}} name</label>
                                        <md-input v-model="account.name" />
                                    </md-field>
                                    <div class="form__error">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <md-field>                            
                                        <label>E-mail</label>
                                        <md-input v-model="account.email" />
                                    </md-field>
                                    <div class="form__error">{{ errors[0] }}</div>
                                </ValidationProvider>
                                <md-button class="btn btn-blue" type="submit">
                                    <img src="@/assets/img/icons/buttons/ic-add-blue.svg" />
                                    add {{userType}}
                                </md-button>
                            </form>     
                        </validation-observer>
                    </div>  
                    <div v-else-if="userType == 'account'">
                        <InviteAccount @refreshAccounts="refreshAccounts()" :key="refreshKey"  :type="'account'" :title="'Invite account'" :creative_companies="creative_companies"/>
                    </div>              
                </div>

                <md-dialog-actions>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                        </div>
                        <div class="md-layout-item text-right">
                            <md-button class="md-primary modal-save-btn" type="button" @click="cancel">Save {{userType}} list</md-button>
                        </div>
                    </div>
                </md-dialog-actions>
           </div>
        </md-dialog>
        <!-- CTA button -->
        <span v-if="!designerView" class="hrefButton" @click="showDialog = true" >Edit contact list</span>        
    </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';
import InviteAccount from '@/components/pagesComponents/accounts/InviteAccount.vue';
setInteractionMode('eager');
extend('required', {
  ...required,
  message: "This field is required"
});

export default {
  
  mixins: [apiHandlerMI],
  props: ['brand','users', 'userType', 'accountView','designerView'],
  data(){
    return{
      refreshKey : 0,
      showDialog: false,
      active: false,
      creative_companies: [],
      account: {
        name: '',
        email: ''
      },
      error: {}      
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    InviteAccount
  },
    mounted(){
        this.refreshCreativeCompany();
    },
    methods:{
        refreshAccounts(){
            console.log('refreshACCOUNTS')
            if (this.$parent.refreshClients)
            {
                this.$parent.refreshClients()
            }
        },
        refreshCreativeCompany(){
            var _this = this;
            _this.get('creative_company',{},function(resp){
                _this.creative_companies = resp.data.creative_company;
                _this.refreshKey++;
                _this.$forceUpdate();
            })
        },
      invited(c){
          if (this.brand.user){
              for (var i = 0; i<this.brand.user.length ; i++){
                  if (this.brand.user[i].id == c.id)
                  {
                      return true
                  }
              }
          }
          return false;
      },
      pending(c){
          if (c.status != 'active')
            return true
        return false;
      },
      inviteAccount(){          
        var _this = this;
        let postUrl = ''

        if (this.userType == 'account'){
            postUrl = 'usermanager/inviteaccount'
        } else {
            postUrl = 'usermanager/inviteclient'
            
           _this.account.client_id = this.brand.client_id
        }

        _this.post(postUrl,_this.account,{},function(resp){
            var user = resp.data.user;
            _this.post('user_to_brand',{user_id: resp.data.user.id, brand_id : _this.brand.id},{});
            _this.post('emailsender/1/1',{
                to: user.email,
                data_replace:{
                    sender_user: _this.$store.state.user.name,
                    name: user.name,
                    token: user.token,
                    url: "http://localhost:8080/",
                }
            },{},function(){
                _this.account = {
                    name: '',
                    email: ''
                }
                if (_this.$parent.refreshClients)
                 _this.$parent.refreshClients();
                setTimeout(function(){
                    _this.refreshKey++
                },2000)
            })
        },function(){
            alert('Valami nem sikerült ellenőrizd az adatokat!');
        })
      },
      addAccountForBrand(c){
          var _this = this;
          _this.post('user_to_brand',{user_id: c.id, brand_id : _this.brand.id},{},function(){
              //console.log( 'rb',_this.$parent.refreshBrand);
              //_this.showDialog = false
              if ( _this.$parent.refreshBrand)
                _this.$parent.refreshBrand()
          });
      },
      removeAccountForBrand(c){
          var _this = this;
          _this.delete('user_to_brand',{params:{where:[['where','user_id',c.id],['where','brand_id',_this.brand.id]] }},function(){
              //_this.showDialog = false
              if ( _this.$parent.refreshBrand)
                _this.$parent.refreshBrand()
          });
      },
      cancel(){
        this.showDialog = false        
      },
      bodyAddNoScroll(){
          var _body = document.getElementsByTagName('body')[0]

          _body.classList.add('noScroll')
      },
      bodyRemoveNoScroll(){
          var _body = document.getElementsByTagName('body')[0]

          _body.classList.remove('noScroll')
      }
    }
 }

</script>